// extracted by mini-css-extract-plugin
module.exports = {"positionedBox":"ProblemImage_positionedBox__YNIP5","wrapper":"ProblemImage_wrapper__3Gfp_","innerWrapper":"ProblemImage_innerWrapper__223ZH"};